import React, { useEffect, useState } from 'react';
import { FiDownload, FiPlus } from 'react-icons/fi';
import { RiProhibited2Line } from 'react-icons/ri';
import { StudyGuideMatterModal } from './study-guide-matter-modal';
import { StudyGuideMatterDataGrid } from './study-guide-matter-data-grid';
import { useClient } from 'jsonapi-react';
import xlsx from 'json-as-xlsx';
import { DashboardContent } from '@/layouts/dashboard';
import { GuideCustom, GuideCustomHeader, GuideCustomTitle, GuideCustomText, GuideCustomBody } from '@/components/custom/guide';
import { Button, ButtonIcon } from '@/components/ui/button';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideSettings(props) {
  const { uri } = props;

  const playful = usePlayfulStudent();
  const [showModal, setShowModal] = useState(false);
  const [taxonomies, setTaxonomies] = useState([]);
  const [modalTaxonomies, setModalTaxonomies] = useState([]);

  const client = useClient();

  const getUserTaxonomies = async () => {
    const response = await client.fetch('user_taxonomies');
    return response.data;
  };

  useEffect(() => {
    getUserTaxonomies().then(data => {
      const ableTaxonomies = data.filter(taxonomy => taxonomy.status !== 'disabled');
      const modalTaxonomies = data.filter(taxonomy => taxonomy.status === 'disabled');
      setTaxonomies(ableTaxonomies);
      setModalTaxonomies(modalTaxonomies);
    });
  }, [showModal]);

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: '/guia-de-estudos',
        name: 'Guia de estudos',
        isActive: false
      },
      {
        route: uri,
        name: 'Customização do Guia',
        isActive: true
      }
    ]
  };

  const xlsxStructure = [
    {
      sheet: 'Matérias',
      columns: [
        { label: 'Matéria', value: 'Matéria' },
        { label: 'Submatéria', value: 'Submatéria' }
      ],
      content: taxonomies?.map(item => ({
        Matéria: item['taxonomy-name'],
        Submatéria: item['taxonomy-children'].map(item => item.name).join(', ')
      }))
    }
  ];

  const handleDownloadCSV = () => {
    try {
      xlsx(xlsxStructure);
    } catch (e) {
      console.error(e);
    }
  };

  if (playful) {
    return (
      <DashboardContent breadcrumbs={breadcrumbs}>
        <div className="w-full">
          <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-[20px] border border-neutral-lightest bg-white p-5 shadow-card">
            <p
              className="mb-0 text-sm font-bold"
              style={{ color: '#222731' }}
            >
              Aqui estão as <strong>{taxonomies.length} matérias</strong> que já estão no seu guia.
            </p>

            <button
              type="button"
              onClick={handleDownloadCSV}
              className="flex items-center gap-2 rounded-full border border-[var(--color-secondary)] bg-white px-4 py-2 text-sm font-extrabold text-[var(--color-secondary)] transition-transform active:scale-[0.97]"
            >
              <FiDownload className="h-4 w-4" />
              Baixar
            </button>
          </div>

          <p className="mb-3 text-sm text-neutral-500">Você pode adicionar, remover ou bloquear conforme suas prioridades. As mudanças entram em vigor na próxima semana.</p>

          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="relative mb-4 flex w-full items-center justify-center gap-2 overflow-hidden rounded-full py-3 text-sm font-extrabold text-white transition-transform active:scale-[0.97]"
            style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
          >
            <span
              className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-full"
              style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.2) 0%, transparent 100%)' }}
            />
            <FiPlus className="h-4 w-4" />
            Adicionar outras matérias
          </button>

          {modalTaxonomies && (
            <StudyGuideMatterModal
              show={showModal}
              onClose={() => setShowModal(false)}
              taxonomies={modalTaxonomies}
            />
          )}

          {taxonomies && <StudyGuideMatterDataGrid data={taxonomies} />}
        </div>
      </DashboardContent>
    );
  }

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <GuideCustom>
        <GuideCustomHeader>
          <GuideCustomTitle>
            Aqui estão as <strong>{taxonomies.length} matérias</strong> que já estão no seu Guia.
          </GuideCustomTitle>

          {false && (
            <Button variant="outline">
              <ButtonIcon size="md">
                <RiProhibited2Line />
              </ButtonIcon>
              Bloquear matérias
            </Button>
          )}

          <Button
            variant="outline"
            onClick={handleDownloadCSV}
          >
            <ButtonIcon size="md">
              <FiDownload />
            </ButtonIcon>
            Baixar
          </Button>
        </GuideCustomHeader>

        <GuideCustomBody>
          <GuideCustomText>Você pode adicionar, remover ou bloquear conforme suas prioridades. As mudanças entram em vigor na próxima semana</GuideCustomText>

          <Button
            variant="outline-dashed"
            size="sm"
            fullWidth
            onClick={() => setShowModal(true)}
          >
            <ButtonIcon>
              <FiPlus />
            </ButtonIcon>{' '}
            Adicionar outras matérias
          </Button>

          {modalTaxonomies && (
            <StudyGuideMatterModal
              show={showModal}
              onClose={() => setShowModal(false)}
              taxonomies={modalTaxonomies}
            />
          )}

          {taxonomies && <StudyGuideMatterDataGrid data={taxonomies} />}
        </GuideCustomBody>
      </GuideCustom>
    </DashboardContent>
  );
}
